import React, { useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import clsx from "clsx";
import validator from "validator";
import { toast } from "react-toastify";
import Box from "@mui/material/Box";
import Input from "../../components/common/InputField";
import PasswordField from "../../components/common/passwordInput";
import ButtonMain from "../../components/common/ButtonMain";
import FooterTrustChat from "../../components/common/FooterTrustChat";
import { ReactComponent as TrustChatLogo } from "../../assets/images/Trustchat1.svg";
import { getPlatformSession, signInPlatformAdmin } from "../../components/platformAdmin/platformAuth";
import "../Login/style.css";
import "../../components/platformAdmin/platformAdmin.css";

export default function PlatformLogin() {
  const navigate = useNavigate();
  const location = useLocation();
  const redirectTo = location.state?.from || "/platform-admin/overview";

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [errors, setErrors] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  if (getPlatformSession()?.token) return <Navigate to={redirectTo} replace />;

  const canSubmit = email.trim() && password.trim() && !loading;

  const handleSubmit = async (e) => {
    e?.preventDefault();
    if (!validator.isEmail(email.trim())) {
      setErrors({ email: "Please enter a valid email address", password: "" });
      return;
    }
    setLoading(true);
    const result = await signInPlatformAdmin({ email, password, rememberMe });
    setLoading(false);
    if (!result.ok) {
      setErrors({ email: "", password: "", [result.field]: result.message });
      return;
    }
    toast.success(`Welcome back, ${result.staff.name}`);
    navigate(redirectTo, { replace: true });
  };

  return (
    <div className="main-login-container">
      <Box sx={{ width: "100%", height: 64, px: "24px", display: "flex", alignItems: "center", gap: "10px", boxSizing: "border-box" }}>
        <TrustChatLogo />
        <span className="platform-admin-sidebar-badge">Platform</span>
      </Box>

      <div className="adminPanelMainDiv__login">
        <form
          className="inputDivStyle-login"
          onSubmit={handleSubmit}
          onKeyDown={(e) => {
            if (e.key === "Enter" && canSubmit) handleSubmit(e);
          }}
          noValidate
        >
          <div className="textDiv__login">
            <p className="text__create">Platform Admin</p>
            <p className="text__start">Sign in with your TrustChat staff account</p>
          </div>

          <Input
            name="email"
            id="platform-admin-email"
            type="email"
            title="Email"
            placeholder="you@trustchat.io"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setErrors((prev) => ({ ...prev, email: "" }));
            }}
            error={errors.email}
            className={clsx(errors.email ? "input__error" : "")}
          />
          <br />
          <PasswordField
            name="password"
            id="platform-admin-password"
            type="password"
            title="Password"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              setErrors((prev) => ({ ...prev, password: "" }));
            }}
            error={errors.password}
            className={clsx(errors.password ? "input__error" : "")}
          />

          <div className="check__box">
            <div className="block__check">
              <input
                type="checkbox"
                className="custom-checkbox"
                id="platformAdminRememberMe"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
              />
              <label htmlFor="platformAdminRememberMe">
                <span className="Remember__01">Keep me signed in</span>
              </label>
            </div>
          </div>

          <div className="btn-class">
            <ButtonMain
              title={loading ? "Signing in..." : "Sign in"}
              onClick={handleSubmit}
              className={canSubmit ? "buttonStyleEnable" : "buttonStyleDisabled"}
              disabled={!canSubmit}
            />
          </div>
        </form>
      </div>
      <FooterTrustChat />
    </div>
  );
}
